import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '../../ui/dialog';
import { Button } from '../../ui/button';
import { Textarea } from '../../ui/textarea';

interface BulkEditDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  value: string;
  onChange: (value: string) => void;
  onSave: () => void;
  hasExistingItems: boolean;
  canEdit?: boolean;
}

export const BulkEditDialog = ({
  open,
  onOpenChange,
  value,
  onChange,
  onSave,
  hasExistingItems,
  canEdit = true
}: BulkEditDialogProps) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[525px] max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>{hasExistingItems ? 'Edit Format Template' : 'Create Format Template'}</DialogTitle>
          <DialogDescription>
            Enter model format template items, one per line. Format: "HH:MM Description"
          </DialogDescription>
        </DialogHeader>
        <div className="grid gap-4 py-4">
          <Textarea
            value={value}
            onChange={(e) => onChange(e.target.value)}
            placeholder="12:05 Interaction&#10;12:35 💗&#10;01:05 Self Swap&#10;01:35 Group A Promo AM / 💗 PM"
            className="h-[600px] font-mono"
          />
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => {
            onOpenChange(false);
            onChange('');
          }}>
            Cancel
          </Button>
          <Button onClick={onSave} disabled={!canEdit}>
            Save changes
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}; 